import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {ContactPageVO, useQueryContactPage} from "@/service/contact.s";
import {WriteContact} from "@/pages/Contact/WriteContact";
import {Avatar} from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import {ViewContact} from "@/pages/Contact/ViewContact";
import {permScope} from "@/helper/constant";
import {useAuthInfo} from "@/store/account.c";

export const ContactListPage = () => {
    const {
        mutate: contactPageMutate,
        data: contactPageData,
        isPending: contactPagePending,
    } = useQueryContactPage()
    const {role: {dataScope}} = useAuthInfo()

    const columns: GridColDef<ContactPageVO>[] = [
        {
            field: "name",
            headerName: "姓名",
            flex: 0.4
        },
        {
            field: "mobile",
            headerName: "联系电话",
            headerAlign: "center",
            align: "center",
            flex: 0.5
        },
        {
            field: "email",
            headerName: "邮箱",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            valueFormatter: value => value || "-"
        },
        {
            field: "gender",
            headerName: "性别",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
            valueFormatter: value => value == 1 && "男" || value == 2 && "女" || "未知"
        },
        {
            field: "post",
            headerName: "职位",
            headerAlign: "center",
            align: "center",
            flex: 0.4
        },
        {
            field: "firsted",
            headerName: "首要联系人",
            headerAlign: "center",
            align: "center",
            display: 'flex',
            flex: 0.5,
            renderCell: ({row: {firsted}}) => {
                return firsted == 1 ? <CheckOutlinedIcon color={'disabled'}/> : <ClearOutlinedIcon color={'disabled'}/>
            }
        },
        {field: "customerName", headerName: "客户名称", minWidth: 120, flex: 0.6, valueFormatter: value => value || "-"},
        {
            field: "seller",
            headerName: "业务人员",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            display: 'flex',
            renderCell: ({row}) => <Avatar {...stringAvatar(row.seller)} />
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "center",
            flex: 0.4,
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    return (
        <ProTable<ContactPageVO>
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            loading={contactPagePending}
            renderDrawer={{view: <ViewContact/>, write: <WriteContact/>}}
            columns={columns}
            data={contactPageData?.data}
            onSearch={(params) => {
                contactPageMutate(params);
            }}
            code={"contact"}
        />
    );
};
